<script setup>
    import { ref, defineProps, watchEffect  } from "vue";
    const items = ref(false);
    const props = defineProps({
        items: {
            type: Array,
            required: true
        },
        arrowIcon: {
            type: Image,
            required: false
        },
        currentView:{
            type: String,
            required: false
        },
        cbAfterOpen:{
            type: Function,
            required: false
        },
        cbAfterClose:{
            type: Function,
            required: false
        }
    })
    
    const toggle = (index) => {
        if( !items.value[index].open){
            if( props.cbAfterOpen ) props.cbAfterOpen(index);
        } else{
            if( props.cbAfterClose ) props.cbAfterClose(index);
        }
        items.value[index].open = !items.value[index].open;
    };
    watchEffect(() => {
        items.value = props.items.map( (item) => ({...item, open: false}) );
    })
</script>

<template>
    <div :class="[currentView]" class="accordion" >
        <template v-if="items">
            <div v-for="(item, index) in items" :key="index" class="accordion__item">
                <div class="accordion__header" @click="toggle(index)">
                    {{ item.question }}
                    <div :class="{opened: item.open }" class="accordion__arrow"></div>    
                </div>
                <Transition>  
                    <div v-if="item.open" class="accordion__content" v-html="item.answer">
                    </div>
                </Transition>
             </div>
        </template>
    </div>
</template>
  
<style scoped lang="scss">
  .accordion {
        text-align: left;
   }
  
   .accordion__item {
      margin: 10px;
   }
   .accordion__arrow {
        position: absolute;
        line-height: 0;
        width: 30px; height: 30px;
        background: black;
        right: 0.5rem; top: -0.2rem;
        transition: all 0.3s;
        transform: rotate(0);  
        &.opened{
            transform: rotate(180deg);
        }
    }
    .accordion__header {
        font-size: 1rem;
        position: relative;
        cursor: pointer;
        padding-bottom: 0.3rem;
    }
    .accordion__content {
        font-size: 1rem;
        color: grey;
        :deep() { 
            p {
                margin-top: 0 ;
            }
            img{
                width: 80%;
                margin: 0.5rem 0;
            }
        }
    }
    .v-enter-active,
    .v-leave-active {
    transition: opacity 0.5s ease;
    }

    .v-enter-from,
    .v-leave-to {
    opacity: 0;
    }
</style>